export { syntheticEvent } from './SyntheticEvent';